import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { UserSession } from "@modules/api/user-session.generated";
import { SessionExpirationDialogComponent } from "@modules/common/components/session-expiration-dialog/session-expiration-dialog.component";
import { SessionExpirationDialogArgs } from "@modules/common/models/session-expiration-dialog-args";
import { SessionExpirationDialogResult } from '@modules/common/models/session-expiration-dialog-result';
import { LogoutService } from "@modules/common/services/logout.service";
import { RefreshSessionService } from "@modules/common/services/refresh-session.service";
import { UserSessionService } from '@modules/common/services/user-session.service';
import * as moment from 'moment';

const SHOW_MODAL_THRESHHOLD = 180; //number of seconds before session expires to show the modal

@Injectable({
    providedIn: 'root'
})
export class UserSessionTimeoutService {
    constructor(
        private _userSessionService: UserSessionService,
        private _dialog: MatDialog,
        private _refreshSessionService: RefreshSessionService,
        private _logoutService: LogoutService
    ) { }

    public initialize() {
        this._userSessionService.userSessionChanged().subscribe(result => {
            if (this._sessionExpirationTimeout) {
                clearTimeout(this._sessionExpirationTimeout);
            }
            if (result && result.authenticationToken) {
                this.setSessionTimeout(moment.utc(this._userSessionService.getUserSession()!.authenticationToken!.expiresAt).diff(moment.utc(), 'seconds') - SHOW_MODAL_THRESHHOLD);
            }
        });
    }

    private _sessionExpirationTimeout?: number;


    private setSessionTimeout(timeoutDuration: number) {
        this._sessionExpirationTimeout = window.setTimeout(() => {
            const session = this._userSessionService.getUserSession();

            if (session
                && session.authenticationToken
                && session.authenticationToken.expiresAt
                && moment.utc(session.authenticationToken.expiresAt).diff(moment.utc(), 'seconds') <= SHOW_MODAL_THRESHHOLD + 2 //+2 is just for a little safety if the modal shows early (which should never happen)
            ) {
                this._dialog.open<SessionExpirationDialogComponent, SessionExpirationDialogArgs, SessionExpirationDialogResult>(SessionExpirationDialogComponent, {
                    disableClose: true,
                    data: {
                        expirationDate: session.authenticationToken.expiresAt,
                        token: session.authenticationToken.token
                    }
                }).afterClosed().subscribe(result => {
                    if (result) {
                        if (result.action == 'signOut') {
                            this._logoutService.logout(result.clearRedirectedFromUrl);
                        } else if (result.action == 'refresh') {
                            this.refreshSession();
                        }
                    }
                });
            }
        }, timeoutDuration * 1000);
    }

    private refreshSession() {
        this._refreshSessionService.refreshSession({
            authenticationToken: this._userSessionService.getUserSession()!.authenticationToken!.token!,
            refreshToken: this._userSessionService.getUserSession()!.refreshToken!
        }).subscribe((result?: UserSession) => {
            if (result) {
                this._userSessionService.setUserSession(result);
            }
        });
    }
}
